import React from 'react';
import { Link } from 'react-router-dom';
import oba from '../imgs/OBA.png';

import nivel3_25_oba from '../docs/gabaritos/gabaritos-astronomia/OBA/GabaOBA2025N3.pdf';
import nivel4_25_oba from '../docs/gabaritos/gabaritos-astronomia/OBA/GabaOBA2025N4.pdf';


const AstronomiaGab = () => {
    return (
        <div>
            <h1 className="fontizzao">GABARITOS COMENTADOS - ASTRONOMIA</h1>
            <hr className="line3"></hr>
            <center>
            <div className="text-container2">
                <h4 className="corzaoo">
                    Para os estudantes ansiosos por conferir seus acertos nas principais olimpíadas e seletivas do Brasil, esta seção foi feita para você. Aqui, você poderá acompanhar seu desempenho e avaliar sua evolução rumo ao sucesso. Preparado(a) para conferir seus resultados?
                </h4>
            </div>
            <br/>
            </center>
            <div className="fundo">
                <center>
                <div className="equipe-container">
                    <div className="membro">
                        <img src={oba} className="imagem-circular"/>
                    </div>
                </div>
                <br/>
                <div className="button-container-diff">
                    <button className="botao-transparente2-selected">OBA</button>
                </div>
                <br/>
                <div className="text-container11">
                        <h4 className="fontezao7cor">2025</h4>
                </div>
                <div className="button-container-diff">
                    <a href={nivel3_25_oba}>
                        <button className="botao-transparente2-diff">Nível III</button>
                    </a>
                </div>
                <br/>
                <div className="button-container-diff">
                    <a href={nivel4_25_oba}>
                        <button className="botao-transparente2-diff">Nível IV</button>
                    </a>
                </div>
                </center>
                <br/>
            </div>
        </div>
    );
}

export default AstronomiaGab;